import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps<"companyIds"> {}

export function CompaniesDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="companyIds"
			allOption
			values={props.options?.data ?? []}
			objectName="Companies"
			label={props.label ?? "Company"}
			fullLength
			isMulti
		/>
	);
}
